module.exports = __webpack_public_path__ + "static/media/nancy-lublin.73e3611b.png";